import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import PsType from './PsType.jsx'
import Model from './ModelPs.mjs'

const PropertiesPanePs = (props) => (
    <ComponentPropertiesPane
        controllers={
            <>
                <LongText prop="psName" />

                <Select
                    options={PsType}
                    prop="psTypeCode"
                />

                <LongText prop="psDesc" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPanePs
